import * as LucideIcons from 'lucide-react';
import styles from './Icon.module.css';

// Thin wrapper around lucide-react so callers can pass a string name and
// we keep stroke/size/color consistent with the brutalist design system.
//
// Usage:
//   <Icon name="Sparkles" />
//   <Icon name="X" size={20} tone="danger" />
//
// `name` must match a Lucide export. Unknown names render a placeholder
// square so missing icons are obvious during development.

const TONE_CLASS = {
  default: styles.toneDefault,
  muted: styles.toneMuted,
  dim: styles.toneDim,
  accent: styles.toneAccent,
  cyan: styles.toneCyan,
  danger: styles.toneDanger,
  warning: styles.toneWarning,
  inverted: styles.toneInverted,
};

export default function Icon({
  name,
  size = 16,
  strokeWidth = 2,
  tone = 'default',
  className = '',
  ...rest
}) {
  const LucideIcon = LucideIcons[name];

  const toneClass = TONE_CLASS[tone] || TONE_CLASS.default;
  const combined = [styles.icon, toneClass, className].filter(Boolean).join(' ');

  if (!LucideIcon) {
    return (
      <span
        aria-hidden="true"
        className={combined}
        style={{ width: size, height: size, display: 'inline-block', border: '1px dashed currentColor' }}
        {...rest}
      />
    );
  }

  return (
    <LucideIcon
      size={size}
      strokeWidth={strokeWidth}
      className={combined}
      aria-hidden="true"
      {...rest}
    />
  );
}
